import moment from 'moment';
import { ExportType__Output } from '@generated/grpc/spotify/catalogexport/v1';

export enum DATE_RANGE_TYPE {
  LAST_7_DAYS = 'Last 7 days',
  LAST_28_DAYS = 'Last 28 days',
  LAST_90_DAYS = 'Last 90 days',
  CUSTOM_DATES = 'Custom dates',
  ALL_TIME = 'All time',
}

export type DateRangeString = {
  startDate: string;
  endDate: string;
};

export type DateRangeMoment = {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
};

export type FormValues = {
  exportType: ExportType__Output;
  startDate: string;
  endDate: string;
  exportFileName: string;
};
